import { useState } from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const bannerAnimation = {
  initial: { y: 100, opacity: 0 },
  animate: { y: 0, opacity: 1 },
  exit: { y: 100, opacity: 0 },
  transition: { duration: 0.4 },
};

export default function CookieBanner() {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(
    () => !localStorage.getItem("medboard_cookie_consent")
  );

  const handleAccept = () => {
    localStorage.setItem("medboard_cookie_consent", "accepted");
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem("medboard_cookie_consent", "rejected");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          {...bannerAnimation}
          data-testid="cookie-banner"
          className="fixed bottom-0 left-0 right-0 z-50 bg-[#131b2f] border-t border-[#2a3449] px-6 py-6 shadow-[0_-8px_30px_rgba(0,0,0,0.4)]"
        >
          <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center gap-5">
            <div className="flex items-start gap-4 flex-1">
              <Cookie size={22} className="text-[#1a6cf5] shrink-0 mt-0.5" />
              <div>
                <p
                  data-testid="cookie-text"
                  className="font-outfit text-sm text-[#f8f9fa] leading-relaxed"
                >
                  {t("cookie.text")}
                </p>
                <Link
                  to="/privacy"
                  data-testid="cookie-privacy-link"
                  className="font-outfit text-xs text-[#1a6cf5] hover:underline mt-1 inline-block"
                >
                  {t("footer.privacy")}
                </Link>
              </div>
            </div>
            <div className="flex gap-3 shrink-0">
              <button
                onClick={handleReject}
                data-testid="cookie-reject-btn"
                className="bg-[#1a6cf5] hover:bg-[#3b82f6] text-white font-outfit text-sm font-medium px-7 py-3 rounded-full transition-all duration-300"
              >
                {t("cookie.reject")}
              </button>
              <button
                onClick={handleAccept}
                data-testid="cookie-accept-btn"
                className="bg-[#1a6cf5] hover:bg-[#3b82f6] text-white font-outfit text-sm font-medium px-7 py-3 rounded-full transition-all duration-300"
              >
                {t("cookie.accept")}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
